angular.module('unergie.main')
.factory('FilterMapping', (ReferencesService, ErrorCatcher) => {
    return {
        contractStatus: () => {
            return ReferencesService.getRef('contractStatus')
            .then((mapping) => _.map(JSON.parse(angular.toJson(mapping)), (value, key) => ({ id: `${key}`, title: _.get(value, '[0].label_fr') })))
            .catch(ErrorCatcher.catchError)
        },
        suspensionStatus: [
            { id: '<null>', title: 'Alimenté' },
            { id: 'SUSPENDED', title: 'Coupé' },
            { id: 'SUSPENSION_REQUESTED', title: 'Coupure demandée' },
            { id: 'LIMITED', title: 'Limité' },
            { id: 'LIMITATION_REQUESTED', title: 'Limitation demandée' },
        ],
        terminationOrigin: [
            { id: '<null>', title: 'Sans origine' },
            { id: 'PROVIDER', title: 'Fournisseur' },
            { id: 'CLIENT', title: 'Client' },
        ],
        trigger: [
            { id: '<null>', title: 'Sans origine' },
            { id: 'PROVIDER', title: 'Fournisseur' },
            { id: 'CLIENT', title: 'Client' },
        ],
        metaInvoiceTypes: [
            { id: 'INVOICE', title: 'Facture' },
            { id: 'REVERSAL', title: 'Extourne' },
            { id: 'PENALTY', title: 'Pénalité' },
            { id: 'COMPENSATION', title: 'Rétribution' },
        ],
        invoiceStatuses: [
            { id: '0', title: 'INITIAL' },
            { id: '1', title: 'HOLD' },
            { id: '10', title: 'PROCESSING' },
            { id: '11', title: 'VALUATED' },
            { id: '12,20,21,502', title: 'TO_CHECK' },
            { id: '30', title: 'EXTERNAL PROCESSING' },
            { id: '31', title: 'TIMETABLE OK' },
            { id: '41', title: 'SIMULATING' },
            { id: '42', title: 'RUNNING' },
            { id: '49', title: 'HOLD PREPARED' },
            { id: '501', title: 'SIMU OK' },
            { id: '500', title: 'SIMU TT OK' },
            { id: '50', title: 'DONE' },
            { id: '54', title: 'PARTIAL' },
            { id: '55', title: 'INVOICED' },
            { id: '59', title: 'HOLD DONE' },
            { id: '70', title: 'CANCELLED' },
            { id: '71', title: 'CANCELED_NO_CHANGE' },
            { id: '75', title: 'REVERTED' },
            { id: '90', title: 'ERROR' },
            { id: '91', title: 'ERROR VALO' },
            { id: '92', title: 'ERROR PREP' },
            { id: '93', title: 'ERROR PDF' },
            { id: '94', title: 'ERROR SIMU TT' },
            { id: '95', title: 'ERROR TT' },
            { id: '96', title: 'ERROR SENDING' },
            { id: '99', title: 'ERROR SIMU' },
        ],
        invoiceTypes: [
            { id: 'MISC', title: 'Frais' },
            { id: 'MISC_REVERSAL', title: 'Annulation Frais' },
            { id: 'REG', title: 'Régularisation' },
            { id: 'REG_REVERSAL', title: 'Annulation facture' },
            { id: 'REG_FINAL', title: 'Facture de résiliation' },
            { id: 'REG_FINAL_REVERSAL', title: 'Annulation facture de résil.' },
        ],
        paymentStatuses: [
            { id: '0', title: 'A transmettre' },
            { id: '10', title: 'En traitement' },
            { id: '11', title: 'En traitement CB' },
            { id: '40', title: 'En attente validation' },
            { id: '50', title: 'Transmis à slimpay' },
            { id: '51', title: 'OK - En traitement' },
            { id: '55', title: 'OK' },
            { id: '70', title: 'Annulé' },
            { id: '90', title: 'En erreur' },
            { id: '91', title: 'Non présenté' },
            { id: '93', title: 'rTransaction' },
            { id: '94', title: 'Traitement rTransac' },
            { id: '95', title: 'rTransac - OK' },
            { id: '96', title: 'rTransac rejoué' },
        ],
        taxDeclarationStatuses: [
            { id: 'INITIAL', title: 'Initial' },
            { id: 'PROCESSING_SIMU', title: 'En cours de simulation' },
            { id: 'SUCCESS_SIMU', title: 'Simulation OK' },
            { id: 'ERROR_SIMU', title: 'Erreur de simulation' },
            { id: 'ERROR', title: 'Erreur' },
            { id: 'PROCESSING_RUN', title: 'En cours de traitement' },
            { id: 'PROCESSING_DONE', title: 'Cloturée' },
            { id: 'GENERATING_SYNC_DATA', title: 'En cours de génération' },
            { id: 'ERROR_SYNC_DATA', title: 'Erreur de synchronisation' },
            { id: 'CANCELLED', title: 'Annulée' },
        ],
        taxDeclarationTypes: [
            { id: 'TCCFE', title: 'TCCFE' },
            { id: 'TDCFE', title: 'TDCFE' },
        ],
        simpleStatuses: [
            { id: 'DRAFT', title: 'Draft' },
            { id: 'TO_ACTIVATE', title: 'Activation en cours' },
            { id: 'ACTIVE', title: 'En service' },
            { id: 'CANCELLED', title: 'Annulé' },
            { id: 'TERMINATED', title: 'Résilié' },
        ],
        organizationTypes: [
            { id: 'SUPERVISOR', title: 'Supervision' },
            { id: 'PROVIDER', title: 'Fournisseur' },
            { id: 'CSR', title: 'Service client' },
            { id: 'SALES', title: 'Vente' },
            { id: 'B2G', title: 'Administration (B2G)' },
            { id: 'B2B', title: 'Pro (B2B)' },
            { id: 'PARTNER', title: 'Partenaire' },
        ],
    }
})
